import "./style.scss"
import "react-toastify/dist/ReactToastify.css"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import React, { useEffect, useState } from "react"
import { ToastContainer } from "react-toastify"
// The SDK entry loads its own stylesheet; no separate CSS import is needed.
import {
  AuthModal,
  CheckoutProvider,
  hooks
} from "tf-checkout-react"

import { CHECKOUT } from "../../config/checkout"
import { useCheckoutLocale } from "../../i18n/useCheckoutLocale"
import { configureCheckoutKit } from "../../utils/checkout-kit-config"
import Header from "../header"

configureCheckoutKit()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 60_000
    }
  }
})

export const customStyles = {
  content: {
    background: "black",
    position: "unset"
  }
}

const LayoutContent = ({ children, className, autoShowLoginIfNotLogged }) => {
  const { isAuthenticated } = hooks.useAuthSession()
  const [showLogin, setShowLogin] = useState(false)
  const locale = useCheckoutLocale()

  useEffect(() => {
    if (autoShowLoginIfNotLogged && !isAuthenticated) {
      setShowLogin(true)
    }
  }, [autoShowLoginIfNotLogged, isAuthenticated])

  return (
    <>
      <Header setShowLogin={setShowLogin} />
      <main className={`main-layout-content ${className ?? ""}`}>
        {showLogin && !isAuthenticated && (
          <CheckoutProvider theme={CHECKOUT.theme} locale={locale}>
            <AuthModal
              open
              onClose={() => setShowLogin(false)}
              allowRegistration
              allowPasswordReset
              requireRegistrationAddress
              logoUrl={CHECKOUT.logo}
              onAuthenticated={() => setShowLogin(false)}
            />
          </CheckoutProvider>
        )}
        {children}
      </main>
      <ToastContainer autoClose={10000} />
    </>
  )
}

const Layout = ({ children, className, autoShowLoginIfNotLogged = false }) => (
  <QueryClientProvider client={queryClient}>
    <LayoutContent
      className={className}
      autoShowLoginIfNotLogged={autoShowLoginIfNotLogged}
    >
      {children}
    </LayoutContent>
  </QueryClientProvider>
)

export default Layout
